/* eslint-disable linebreak-style */
export const SET_CURRENT_USER_START = 'SET_CURRENT_USER_START';
export const SET_CURRENT_USER_SUCCESS = 'SET_CURRENT_USER_SUCCESS';
export const SET_CURRENT_USER_FAILURE = 'SET_CURRENT_USER_FAILURE';

export const  SET_DELIVERY_ADDRESSES_START= 'SET_DELIVERY_ADDRESSES_START';
export const  SET_DELIVERY_ADDRESSES_SUCCESS= 'SET_DELIVERY_ADDRESSES_SUCCESS';
export const  SET_DELIVERY_ADDRESSES_FAILURE= 'SET_DELIVERY_ADDRESSES_FAILURE';